import api from './api';

const budgetSheetOptionsService = {
  getAll: async () => {
    const response = await api.get('/budget-sheet-options');
    return response.data;
  },

  getByTipo: async (tipo) => {
    const response = await api.get(`/budget-sheet-options?tipo=${tipo}`);
    return response.data;
  },

  getTipos: async () => {
    const response = await api.get('/budget-sheet-options/tipos');
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/budget-sheet-options', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/budget-sheet-options/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/budget-sheet-options/${id}`);
    return response.data;
  }
};

export default budgetSheetOptionsService;
